// extracted by mini-css-extract-plugin
export default {"container":"yY-z","title":"zY-z","link":"AY-z"};